/**
 * Horizontal scroll slider for recommended-products block.
 */
function initRecommendedProductsSlider(root) {
  const viewport = root.querySelector('[data-recommended-products-viewport]');
  const prevBtn = root.querySelector('[data-recommended-products-prev]');
  const nextBtn = root.querySelector('[data-recommended-products-next]');
  const progressThumb = root.querySelector('[data-recommended-products-progress-thumb]');
  if (!viewport || !prevBtn || !nextBtn) {
    return;
  }

  const sync = () => {
    const maxScroll = viewport.scrollWidth - viewport.clientWidth;
    const atStart = viewport.scrollLeft <= 1;
    const atEnd = viewport.scrollLeft >= maxScroll - 1;
    prevBtn.disabled = atStart;
    nextBtn.disabled = atEnd;
    prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');

    if (!progressThumb) {
      return;
    }

    const progress = maxScroll <= 0 ? 1 : Math.max(0, Math.min(1, viewport.scrollLeft / maxScroll));

    progressThumb.style.width = `${progress * 100}%`;
    progressThumb.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
  };

  viewport.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });

  prevBtn.addEventListener('click', () => {
    if (prevBtn.disabled) {
      return;
    }
    viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', () => {
    if (nextBtn.disabled) {
      return;
    }
    viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' });
  });

  const ro = new ResizeObserver(() => sync());
  ro.observe(viewport);

  sync();
}

function initAllRecommendedProductsSliders() {
  document.querySelectorAll('[data-recommended-products-slider]').forEach((el) => {
    if (el.dataset.recommendedProductsSliderReady === 'true') {
      return;
    }
    el.dataset.recommendedProductsSliderReady = 'true';
    initRecommendedProductsSlider(el);
  });
}

document.addEventListener('DOMContentLoaded', initAllRecommendedProductsSliders);
